import { useCallback } from 'react';
import { Enum_LiveStream_Auto_Response } from '@core/api';
import { appContextToTrackingDataPixel } from '@core/tracking';
import { getVideoPlayId } from '@core/tracking/videoPlayIdTracking';
import { useStoreApi } from '@embed/components/VideoPlayer/Player3/store';
import { useVideoPlayerStoreApi } from '@embed/components/VideoPlayer/store';
import { PlaySourceEnum } from '@embed/constants';
/**
 * Hook that provides basic Player properties for tracking events.
 */
export function useGetPlayerNestedTrackingPayload() {
    const store = useStoreApi();
    const videoPlayerStore = useVideoPlayerStoreApi();
    return useCallback(() => {
        const { video, params, appContext } = store.getState();
        const { initialLayout, layout } = videoPlayerStore.getState();
        const videoPlayId = getVideoPlayId(params?.widget_id ?? '', video?.encoded_id ?? '', PlaySourceEnum.PLAYER);
        return {
            ...appContextToTrackingDataPixel({ appContext }),
            initial_player_layout: initialLayout,
            player_layout: layout,
            video_play_id: videoPlayId,
            ai_copilot: video?.live_stream_auto_response ===
                Enum_LiveStream_Auto_Response.ALWAYS_ON
                ? true
                : undefined,
            ai_assistant: video?.live_stream_auto_response ===
                Enum_LiveStream_Auto_Response.ALWAYS_ON
                ? 'auto_pilot'
                : video?.live_stream_auto_response ===
                    Enum_LiveStream_Auto_Response.MODERATED
                    ? 'copilot'
                    : undefined,
            ui_theme: params?.theme || params?.ui_theme,
            ui_player_style: params?.ui_player_style,
        };
    }, [store, videoPlayerStore]);
}
